import { ListItemText } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import I18n from 'i18n-js'
import moment from 'moment'
import { memo } from 'react'
import { makeStyles } from 'tss-react/mui'

import LinkChild from '@src/lib/LinkChild'

import cloudinary from '../../lib/Cloudinary'

import PlatformAvatarGroup from './PlatformAvatarGroup'
import reportingPaths from './reportingPaths'
import { campaignTotals } from './statsTotals'

const useStyles = makeStyles()((theme) => ({
  campaignImage: {
    width: 100,
    height: 56,
    objectFit: 'contain',
    marginRight: theme.spacing(2),
  },
}))

const campaignState = (state) => {
  if (state === 'complete') return I18n.t('reporting.completed')
  else {
    return state
  }
}

/** @type {React.FC<{campaign: import('@promoboxx/graphql-gateway-types').AdCampaignData, params: {retailerAccountSlug: string, brandSlug: string, campaignType: string} => void}>} */
const PremiumCampaignListItem = (props) => {
  const { classes } = useStyles()

  // TODO Yeah some premium ads have an invalid brand id
  if (!props.campaign.brand) {
    return null
  }

  const { totals } = campaignTotals(
    ((props.campaign.getStats.stats[0] || {}).data || {}).ads,
  )

  return (
    <TableRow key={props.campaign.id}>
      <TableCell>
        <Box alignItems="center" display="flex">
          <img
            alt={props.campaign.title}
            className={classes.campaignImage}
            src={cloudinary.instance().url(props.campaign.thumbnail.source_id, {
              crop: 'scale',
              width: 100,
              format: 'jpg',
              quality: 'auto',
            })}
          />
          <ListItemText
            primary={props.campaign.title}
            secondary={props.campaign.brand.name}
          />
        </Box>
      </TableCell>
      <TableCell
        sx={{
          // This works around the fact that AvatarGroup has
          // `direction: row-reverse`.
          justifyContent: 'flex-end',
        }}
      >
        <PlatformAvatarGroup platforms={props.campaign.platforms} />
      </TableCell>
      <TableCell>
        {props.campaign.starts_at &&
          moment(props.campaign.starts_at).format('L')}{' '}
        -<br />
        {props.campaign.ends_at && moment(props.campaign.ends_at).format('L')}
      </TableCell>
      <TableCell>
        {props.campaign.state && (
          <Chip
            color="secondary"
            label={campaignState(props.campaign.state).toUpperCase()}
            size="small"
            variant="outlined"
          />
        )}
      </TableCell>
      <TableCell align="center">
        {totals.views !== null ? I18n.l('number', totals.views) : '-'}
      </TableCell>
      <TableCell align="center">
        {totals.actions !== null ? I18n.l('number', totals.actions) : '-'}
      </TableCell>
      <TableCell align="center">
        {totals.clicks !== null ? I18n.l('number', totals.clicks) : '-'}
      </TableCell>
      <TableCell>
        <LinkChild
          to={reportingPaths.paidCampaignDetails.build({
            retailerAccountSlug: props.params.retailerAccountSlug,
            brandSlug: 'all',
            campaignId: props.campaign.id,
          })}
        >
          <Button fullWidth>{I18n.t('shared.view')}</Button>
        </LinkChild>
      </TableCell>
    </TableRow>
  )
}

export default memo(PremiumCampaignListItem)
